import styled from "styles/styled_components";

const StyledScrollBox = styled.div`
  max-height: 50vh;
  overflow-y: auto;
`;

export default StyledScrollBox;
